import { useCallback, useEffect, useMemo, useState } from "react";
import ProFormsLayout from "../../../Components/ProForms/ProFormsLayout";
import ProSelectField from "../../../Components/Inputs/SelectField";
import { Grid } from "@mui/material";
import { changeMode, checkEditEnabled, fieldTruePermission, prepareDefaultValues, prepareInitialConfig } from "../../../../utils/formHelper";
import { useForm } from "react-hook-form";
import Layout from "../../../Components/Layout";
import { CPR_VERSION_SETTING } from "../../../../utils/services/apiPath";
import { getApi, postApi, putApi } from "../../../../utils/services";
import { successToast } from "../../../../utils/toastHelper";
import { STAUTES } from "../../../../utils/constant";
import { CPRVersionDropDown } from "../../../../utils/dropdownHelper";

const cprVersionFormConfing = {
  versionLabel: {
    label: "CPR Version",
    perKey: "versionLabel",
    rules: { required: "CPR Version is required!" }
  }
};

const CPRVersion = () => {
  const isAddMode = false;
  const [cprVersion, setCprVersion] = useState({});
  const [formConfig, setFormConfig] = useState(prepareInitialConfig(cprVersionFormConfing, isAddMode ? "edit" : "read"));
  const isEditModeOn = useMemo(() => checkEditEnabled(isAddMode, formConfig), [isAddMode, formConfig]);
  const { handleSubmit, control, setValue } = useForm({ defaultValues: prepareDefaultValues(cprVersionFormConfing) });
  const defaultFormProps = { control, formValues: cprVersion };
  const [isSaving, setIsSaving] = useState(false);
  const [status, setStatus] = useState(STAUTES.IDLE);
  const onEdit = () => {
    setFormConfig(changeMode("edit"));
  };
  const onCancel = () => {
    setFormConfig(changeMode("read"));
  };

  const onSave = async formData => {
    if (isSaving) return;
    setIsSaving(true);
    setStatus(STAUTES.LOADING);
    const payload = {
      versionLabel: formData.versionLabel
    };
    const data = cprVersion?.cprVersionId
      ? await putApi(`${CPR_VERSION_SETTING}/${cprVersion?.cprVersionId}`, payload)
      : await postApi(CPR_VERSION_SETTING, payload);
    successToast(`CPR Version ${cprVersion?.cprVersionId ? "updated" : "created"} successfully!`);
    const CprVersionData = data;
    setCprVersion(CprVersionData);
    getCprVersion();
    setFormConfig(changeMode("read"));
    setIsSaving(false);
    setStatus(STAUTES.IDLE);
  };

  const updateFormFields = (data, formConfig, setValue) => {
    Object.keys(formConfig).forEach(field => setValue(field, data[field]));
  };

  const getCprVersion = useCallback(async () => {
    const data = await getApi(`${CPR_VERSION_SETTING}`);
    const CprVersionData = data;
    setCprVersion(CprVersionData);
    updateFormFields(CprVersionData, formConfig, setValue);
  }, [formConfig, setValue]);

  useEffect(() => {
    getCprVersion();
  }, []);

  useEffect(() => {
    if (cprVersion?.cprVersionId) {
      setFormConfig(changeMode("read"));
    } else {
      setFormConfig(changeMode("edit"));
    }
  }, [cprVersion]);
  
  return (
    <div>
      <Layout canView={true}>
        <ProFormsLayout
          title={"CPR Version"}
          hideBackbutton={true}
          beingEdited={isEditModeOn}
          hideEdit={false}
          onEdit={onEdit}
          onCancel={onCancel}
          onSave={handleSubmit(onSave)}
          status={status}
        >
          <Grid container spacing={2}>
            <ProSelectField {...defaultFormProps} {...formConfig?.versionLabel} options={CPRVersionDropDown} permission={fieldTruePermission} />
          </Grid>
        </ProFormsLayout>
      </Layout>
    </div>
  );
};

export default CPRVersion;
